<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="mobile"
    size="small"
    label-position="left"
    label-width="290px"
  >
    <el-dialog
      :class="dialogclass"
      width="75%"
      top="6vh"
      :visible.sync="popup"
    >
      <h3 slot="title">Que souhaitez-vous résilier ?</h3>

      <div v-if="description === 'Free'" class="choice-logo">
        <el-radio v-model="form.type" label="internet" border>
          Je souhaite résilier mon offre Freebox
          <img src="/static/images/logos/free.png" />
        </el-radio>
        <el-radio v-model="form.type" label="mobile" border>
          Je souhaite résilier mon forfait Mobile
          <img src="/static/images/logos/freemobile.png" />
        </el-radio>
      </div>

      <div v-else>
        <el-checkbox v-model="form.services" label="Téléphonie mobile" border>
          Forfait mobile
        </el-checkbox>
        <el-checkbox v-model="form.services" label="Téléphonie fixe" border>
          Téléphonie fixe
        </el-checkbox>
        <el-checkbox v-model="form.services" label="Internet" border>
          Offre internet
        </el-checkbox>
      </div>

      <el-button type="danger" @click.prevent="close()">
        Continuer
      </el-button>
    </el-dialog>

    <div v-if="description.toString().match(/(orange|^sfr|bouygues)/i)" class="choice">
      <el-checkbox v-model="form.services" label="Téléphonie mobile" border>
        Je souhaite résilier mon forfait mobile
      </el-checkbox>
      <el-checkbox v-model="form.services" label="Téléphonie fixe" border>
        Je souhaite résilier mon téléphone fixe
      </el-checkbox>
      <el-checkbox v-model="form.services" label="Internet" border>
        Je souhaite résilier mon offre internet
      </el-checkbox>
    </div>

    <template v-else>
      <div v-if="internet" class="choice">
        <template v-if="defaultType === 'mobile'">
          <el-radio v-model="form.type" label="mobile" border>Je souhaite résilier mon forfait Mobile</el-radio>
          <el-radio v-model="form.type" label="internet" border>Je souhaite résilier mon offre Internet</el-radio>
        </template>
        <template v-else>
          <el-radio v-model="form.type" label="internet" border>Je souhaite résilier mon offre Internet</el-radio>
          <el-radio v-model="form.type" label="mobile" border>Je souhaite résilier mon forfait Mobile</el-radio>
        </template>
      </div>
    </template>

    <p class="fields-title" style="border-bottom: 1px solid #f1f1f1;padding-bottom:10px">Vous devez saisir les informations ci-dessous pour résilier votre forfait :</p>

    <div style="display:block">
      <el-form-item ref="phone" label="Votre numéro de ligne" prop="phone" required>
        <span slot="label" class="phone-logo">
          Votre numéro de ligne <img :src="logo"  :class="classname" />
        </span>
        <el-input v-model="form.phone" :placeholder="placeholder" />
      </el-form-item>
    </div>

    <div style="display:none">
      <el-form-item prop="contract" :required="false">
        <span slot="label" class="label-logo">
          Votre numéro <img :src="logo"  :class="classname" />
        </span>
        <el-input v-model="form.contract" />
        <span class="notice">
          <i class="el-icon-info" /> {{ title }}
        </span>
      </el-form-item>
    </div>

    <Cgu
      id="cgu"
      :rows="8"
      :contact="contact"
      currency="eur"
    />

    <el-form-item class="cgu" prop="cgu">
      <el-checkbox v-model="form.cgu">
        J'ai lu et j'accepte les conditions générales ci-dessus
      </el-checkbox>
    </el-form-item>

    <div class="valider">
      <el-button
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Je valide ma demande
      </el-button>

      <p class="delai">
        la résiliation sera effective dans un délai de dix jours maximum à compter de la réception
        du dossier.
        <span class="legal">(Conformément aux dispositions de l’article L.224-39 du code de la
          consommation)</span>
      </p>

      <img src="../../assets/images/secure-payment.png" />
    </div>
  </el-form>
</template>

<script>
import Cgu from '../cgu.vue'

export default {
  props: {
    phone: String,
    contract: String,
    loading: Boolean,
    contact: String,
    type: String,
    description: String,
    reference: String,
    title: String,
    internet: {
      type: Boolean,
      default: true
    },
    services: String
  },
  components: {
    Cgu
  },
  data () {
    const cgu = (rule, value, callback) => {
      if (value !== true) {
        callback(new Error('Vous devez lire et accepter les conditions générales'))
      } else {
        callback()
      }
    }
    let popup = false
    if (this.description === 'Free' || this.description.toString().match(/(orange|^sfr|bouygues)/i)) {
      popup = true
    }
    return {
      popup,
      defaultType: this.type,
      form: {
        phone: this.phone,
        contract: this.contract,
        type: this.type,
        services: this.services.split(','),
        cgu: false
      },
      rules: {
        phone: [
          { required: true, message: 'Sélectionnez un numéro de ligne' }
        ],
        contract: [
          { required: false, message: 'Saisissez votre ' + this.reference, trigger: 'blur' }
        ],
        cgu: [
          { validator: cgu, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    placeholder () {
      return this.form.type === 'mobile' ? '06 XX XX XX XX' : '01 XX XX XX XX'
    },
    logo () {
      return '/static/images/logos/' + this.classname + '.png'
    },
    dialogclass () {
      return 'pre-select ' + this.classname + '-select'
    },
    classname () {
      return this.description.replace(/\s+/g, '').toLowerCase()
    }
  },
  methods: {
    valide () {
      this.$refs.mobile.validate((valid) => {
        if (valid) {
          this.$emit('valide', this.form)
        }
      })
    },
    close () {
      this.popup = false
      this.$refs.phone.onFieldBlur()
    }
  },
  watch: {
    phone (value) {
      this.form.phone = value
    },
    contract (value) {
      this.form.contract = value
    },
    type (value) {
      this.form.type = value
    },
    services (value) {
      this.form.services = value.split(',')
    },
    form: {
      handler (value) {
        if (value) {
          if (value.services.length === 0) {
            value.services = [ value.type === 'mobile' ? 'Téléphonie mobile' : 'Internet' ]
          }
          this.$emit('update:type', value.type)
          this.$emit('update:phone', value.phone)
          this.$emit('update:contract', value.contract)
          this.$emit('update:services', value.services.join(','))
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  #cgu {
    height: 8em;
    overflow: auto;
    max-width: 600px;
    margin: 50px auto 30px;
    text-align: left;
    font-size: 11px;
  }
  .valider {
    img {
      max-width: 250px;
      margin-top: 25px;
    }
  }
  .delai {
    margin-top: 40px;
    color: #000;
    font-size: 14px;

    .legal {
      font-size: 10px;
      display: block;
    }
  }
  .notice {
    color: #444;
    font-size: 12px;
  }
  .el-select {
    width: 100%;
  }
  .choice {
    padding: 50px 0;
  }
  @media (max-width: 767px) {
    .choice {
      padding: 0;

      .el-radio {
        width: 100%;
        margin: 0 0 5px 0 !important;
      }

      .el-checkbox.is-bordered {
        width: 100%;
        margin: 10px 0 0 0 !important;
      }
    }
  }
</style>

<style lang="scss">
  .el-form-item.cgu {
    max-width: 600px;
    margin: 0 auto 15px !important;

    .el-form-item__content {
      padding-top: 10px;
      margin-left: 0 !important;
      text-align: center;
    }
    .el-checkbox__label {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .pre-select {
    .el-dialog__header {
      background-size: 125px;
      background-position: top center;
      background-repeat: no-repeat;
      padding-top: 50px;
    }
    .el-button {
      margin-top: 40px;
    }
    &.free-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/free.png);
      }
    }
    &.orange-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/orange.png);
        background-position: top -31px center;
        background-size: 160px;
      }
    }
    &.sfr-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/sfr.png);
        background-position: top -2px center;
        background-size: 100px;
      }
    }
    &.bouyguestelecom-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/bouyguestelecom.png);
        background-position: top -2px center;
        background-size: 160px;
      }
    }
  }
  .choice-logo {
    position: relative;

    .el-radio {
      padding-bottom: 55px;
    }
    img {
      max-height: 24px;
      display: block;
      margin: 8px auto 0;
    }
  }
  .label-logo, .phone-logo {
    position: relative;

    img {
      max-height: 24px;
      position: absolute;
      left: 110px;
      top: -3px;

      &.orange {
        max-height: 64px;
        left: 90px;
        top: -23px;
      }
      &.sosh {
        max-height: 43px;
        left: 120px;
        top: -13px;
      }
      &.sfr {
        max-height: 32px;
        left: 100px;
        top: -7px;
      }
      &.lapostemobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.nrjmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.auchantelecom {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.m6mobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.virginmobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.transatel {
        max-height: 64px;
        left: 100px;
        top: -25px;
      }
      &.alicemobile {
        max-height: 64px;
        left: 100px;
        top: -25px;
      }
      &.breizhmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.cdiscountmobile {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.lebaramobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.leclercmobile {
        max-height: 40px;
        left: 110px;
        top: -12px;
      }
      &.nordnet {
        max-height: 15px;
        left: 120px;
        top: 0px;
      }
      &.ovhtelecom {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
      &.ozone {
        max-height: 64px;
        left: 110px;
        top: -25px;
      }
    }

    &.phone-logo {
      img {
        padding-left: 40px;
        background: transparent;
      }
    }
  }

  @media (max-width: 767px) {
    .el-card__body .el-dialog {
      width: 100% !important;

      .el-dialog__body {
        padding-top: 0 !important;

        .choice-logo .el-radio {
          width: 100%;
          margin: 0 0 5px 0 !important;
        }

        .el-checkbox.is-bordered {
          width: 100%;
          margin: 10px 0 0 0 !important;
        }
      }
    }

    .pre-select .el-button {
      margin-top: 10px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/mobile.vue